import { useState } from 'react';

export const useHandleComment = () => {
    const [comment, setComment] = useState('');

    const onChangeComment = (inputValue: string) => {
        setComment(inputValue);
    };
    const clearComment = () => {
        setComment('');
    };

    return {
        comment,
        onChangeComment,
        clearComment,
    };
};
